import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../shared/shared.service';
import { API_MODULES } from '../../../core/api-modules';

@Component({
  selector: 'app-product-detail',
  templateUrl: './products-details.component.html',
  styleUrls: ['./products-details.component.scss']
})
export class ProductsDetailsComponent implements OnInit {
  
  product: any = null;
  selectedImage: string = '';
  availableSizes: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private api: SharedService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) this.loadProduct(id);
  }

  async loadProduct(slugs: string) {
    const res: any = await this.api.getBySlugs(API_MODULES.PRODUCT, slugs);
    console.log(res);
    this.product = res?.data;

    // image_url from backend
    this.selectedImage = this.product?.image_url
      ? this.product.image_url
      : 'assets/no-image.png';

    this.availableSizes = this.parseAvailableSizes(this.product?.available_size);
  }

  changeImage(url: string) {
    this.selectedImage = url;
  }

  getImg(path: string) {
    if (!path) {
      return 'assets/no-image.png';
    }
    // If path already starts with http/https, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    // Otherwise, append to base URL
    return this.api.imageBase + path;
  }

  parseAvailableSizes(value: string | null | undefined): string[] {
    if (!value) return [];
    return String(value)
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }
}
